export const getApiErrorMessage = (
    error: unknown,
    fallbackMessage: string,
): string => {
    if (error && typeof error === 'object') {
        const errObj = error as Record<string, any>
        const responseData = errObj.response?.data

        if (responseData && typeof responseData === 'object') {
            if (typeof responseData.responseMessage === 'string' && responseData.responseMessage.trim()) {
                return responseData.responseMessage.trim()
            }

            if (typeof responseData.message === 'string' && responseData.message.trim()) {
                return responseData.message.trim()
            }
        }
        if (typeof errObj.message === 'string' && errObj.message.trim()) {
            return errObj.message.trim()
        }
    }

    return fallbackMessage
}
